/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './Button.scss';

/**
 * @since 3.21
 *
 * The button component may be passed a variant value of primary to get the primary button styling (aka blue).
 * Passing no variant will result in a normal button. Passing any other variant is not currently supported but a
 * className will be passed to the underlying button element.
 */
export default function Button({variant, children, className, type, ...rest}) {
  const classes = classNames('nxrm-button', className, {
    'nxrm-button-primary': variant === 'primary'
  });

  return <button className={classes} type={type || 'input'} {...rest}>
    {children}
  </button>;
}

Button.propTypes = {
  variant: PropTypes.oneOf(['primary']),
  style: PropTypes.object
};
